<template>
  <table id="bank_suggest_table" class="basic data_suggest_table">
    <tbody>
      <tr>
        <th>銀行名</th>
        <td>
          <div class="bank_input_wrap data_input_wrap">
            <input
              type="text"
              autocomplete="off"
              id="search_bank_name"
              name="search_bank_name"
              class="form-control"
              v-model="searchBankName"
              :disabled="selectBankNumber !== null && selectBankNumber !== ''"
              :readonly="isBankLoading"
              @input="inputBank()"
              @compositionstart="isBankComposing = true"
              @compositionend="isBankComposing = false"
              required
            />
            <input type="hidden" id="bank_name" name="bank_name" v-model="selectBankName" />
            <input type="hidden" id="bank_number" name="bank_number" v-model="selectBankNumber" />
            <div class="suggest_wrap">
              <div class="spinner_area" v-if="isBankLoading">
              <clip-loader :loading="isBankLoading" color="#0693e3" size="30px"></clip-loader>
            </div>
            <ul class="suggest_list" v-if="bankSuggestionList.length > 0">
              <li 
                v-for="suggestion in bankSuggestionList"
                :key="suggestion.number"
                @click="selectBankSuggestion(suggestion)"
              >
                {{ suggestion.name }} ({{ suggestion.number }})
              </li>
            </ul>
          </div>
          <a class="clear_btn badge badge-light" @click="clearForm()">
              クリア
            </a>
          </div>
          <div v-if="bankNameError" class="text-danger mt-1">
            {{ bankNameError }}
          </div>
        </td>
      </tr>
      <tr>
        <th>銀行コード</th>
        <td>
          <div>
            <template v-if="selectBankNumber">
              {{ selectBankNumber }}
            </template>
            <template v-else>
              未選択
            </template>
          </div>
          <div v-if="bankNumberError" class="text-danger mt-1">
            {{ bankNumberError }}
          </div>
        </td>
      </tr>
      <tr>
        <th>支店名</th>
        <td>
          <div class="bank_input_wrap data_input_wrap">
            <input
              type="text"
autocomplete="off"
              id="search_branch_name"
              name="search_branch_name"
              class="form-control"
              v-model="searchBranchName"
              :disabled="selectBankNumber === null || selectBankNumber === ''"
              :readonly="isBranchLoading"
              @input="inputBranch()"
              @compositionstart="isBranchComposing = true"
              @compositionend="isBranchComposing = false"
              required
            />
            <input type="hidden" id="branch_name" name="branch_name" v-model="selectBranchName" />
            <input type="hidden" id="branch_number" name="branch_number" v-model="selectBranchNumber" />
<div class="suggest_wrap">
            <div class="spinner_area mt-3" v-if="isBranchLoading">
              <clip-loader :loading="isBranchLoading" color="#0693e3" size="30px"></clip-loader>
            </div>
            <ul class="suggest_list" v-if="branchSuggestionList.length > 0">
              <li 
                v-for="suggestion in branchSuggestionList"
                :key="suggestion.number"
                @click="selectBranchSuggestion(suggestion)"
              >
                {{ suggestion.name }}
              </li>
            </ul>
          </div>
          <a class="clear_btn badge badge-light" @click="clearFormBranch()">
              クリア
            </a>
          </div>
          <div v-if="branchNameError" class="text-danger mt-1">
            {{ branchNameError }}
          </div>
        </td>
      </tr>
      <tr>
        <th>支店番号</th>
        <td>
          <div>
            <template v-if="selectBranchNumber">
              {{ selectBranchNumber }}
            </template>
            <template v-else>
              未選択
            </template>
          </div>
          <div v-if="branchNumberError" class="text-danger mt-1">
            {{ branchNumberError }}
          </div>
        </td>
      </tr>
          </tbody>
  </table>
</template>

<script>
import debounce from 'lodash.debounce';

export default {
  name: "bank-and-bank-branch-suggest-component",
  data() {
    return {
      // 銀行名の検索文字列
      searchBankName: this.bankName ?? '',
      // 銀行を検索中かどうか
      isBankLoading: false,
      // 銀行の候補リスト
      bankSuggestionList: [],
      // 銀行を入力の変換セッション中かどうか
      isBankComposing: false,
      // 選択した銀行コード
      selectBankNumber: this.bankNumber,
      // 選択した銀行名
      selectBankName: this.bankName,
      // 支店名の検索文字列
      searchBranchName: this.branchName ?? '',
      // 支店を検索中かどうか
      isBranchLoading: false,
      // 支店の候補リスト
      branchSuggestionList: [],
      // 支店を入力の変換セッション中かどうか
      isBranchComposing: false,
      // 選択した支店番号
      selectBranchNumber: this.branchNumber,
      // 選択した支店名
      selectBranchName: this.branchName,
    };
  },
  props: {
    // 銀行コードの初期値
    bankNumber: {
      type: String
    },
    // 銀行コードのバリデーションエラーメッセージ
    bankNumberError: {
      type: String
    },
    // 銀行名の初期値
    bankName: {
      type: String
    },
    // 銀行名のバリデーションエラーメッセージ
    bankNameError: {
      type: String
    },
    // 支店番号の初期値
    branchNumber: {
      type: String
    },
    // 支店番号のバリデーションエラーメッセージ
    branchNumberError: {
      type: String
    },
    // 支店名の初期値
    branchName: {
      type: String
    },
    // 支店名のバリデーションエラーメッセージ
    branchNameError: {
      type: String
    }
  },
  methods: {
    inputBank: debounce(function () {
      // 入力の変換セッション中なら処理終了
      if (this.isBankComposing) {
        return;
      }

      // 前にサジェストした分をクリア
      this.clearBank();

      // 検索文字列が空なら処理終了
      if (!this.searchBankName) {
        return;
      }

      this.getBankSuggestionList()
    }, 500),
    getBankSuggestionList() {
      this.isBankLoading = true;
      axios
        .get('/api/bank-suggest/banks', {
          params: { name: this.searchBankName }
        })
        .then((response) => {
          if (response.data.length > 0) {
            this.bankSuggestionList = response.data;
          }
        })
        .catch((error) => {
          console.error('Error fetching bank suggestion list', error);
        })
        .finally(() => {
          this.isBankLoading = false;
        });
    },
    selectBankSuggestion(suggestion) {
      this.selectBankNumber = suggestion.number;
      this.selectBankName = suggestion.name;
      this.searchBankName = suggestion.name;
      this.bankSuggestionList = [];
    },
    inputBranch: debounce(function () {
      // 入力の変換セッション中なら処理終了
      if (this.isBranchComposing) {
        return;
      }

      // 前にサジェストした分をクリア
      this.clearBranch();

      // 検索文字列が空なら処理終了
      if (!this.searchBranchName) {
        return;
      }

      this.getBranchSuggestionList()
    }, 500),
    getBranchSuggestionList() {
      this.isBranchLoading = true;
      axios
        .get('/api/bank-branch-suggest/branches', {
          params: { name: this.searchBranchName, bank_number: this.selectBankNumber }
        })
        .then((response) => {
          if (response.data.length > 0) {
            this.branchSuggestionList = response.data;
          }
        })
        .catch((error) => {
          console.error('Error fetching bank-branch suggestion list', error);
        })
        .finally(() => {
          this.isBranchLoading = false;
        });
    },
    selectBranchSuggestion(suggestion) {
      this.selectBranchNumber = suggestion.number;
      this.selectBranchName = suggestion.name;
      this.searchBranchName = suggestion.name;
      this.branchSuggestionList = [];
    },
    clearForm() {
      this.searchBankName = '';
      this.clearBank();

this.searchBranchName = '';
      this.clearBranch();
    },
    clearFormBranch() {
      this.searchBranchName = '';
      this.clearBranch();
    },
    clearBank() {
      this.bankSuggestionList = [];
      this.selectBankNumber = null;
      this.selectBankName = null;
    },
    clearBranch() {
      this.branchSuggestionList = [];
      this.selectBranchNumber = null;
      this.selectBranchName = null;
    },
  },
};
</script>
